// import getBlogs from './getBlogs';
import { AppConfig } from '../../../app-config'
import { triggerSimpleAjax } from '../../../utils/http-helper'
import get from '../../../utils/lodashUtils/get'

export function getPackagesV1(requestObj, locale) {
	return new Promise((res, rej) => {
		let url = `${AppConfig.api_url}packages`
		triggerSimpleAjax({
			locale,
			url,
			method: 'POST',
			body: requestObj,
			onSuccess: async response => {
				if (response.status === 'SUCCESS') {
					let regionName

					const pageData = response.data
					regionName = get(response.data, 'campaignDetails.region')
					// if (!isDeal && !isStaycation) {
					//   await dispatch(getBlogs(`?limit=8&key=${regionName}`));
					// }

					return res({ ...pageData, displayCurrency: response.displayCurrency })
				} else {
					return rej(response)
				}
			},
			onFailure: error => {
				return rej(error)
			},
		})
	})
}
